import {useTranslation} from "react-i18next";
import {useAuth} from "../../setup/auth/authService";
import AuditLogsPanel from "../modules/layout/components/AuditLogsPanel";

const Home = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const preferredName = `${user?.profile?.given_name || ''} ${user?.profile?.family_name || ''}`.trim();
  const displayName = (user && !user.expired) ? (user?.profile?.name || preferredName) : 'User';
  

    return (
        <div className="px-3">

            <div className="text-center mb-5">
                <h2>{t('Welcome')}, {displayName}</h2>
            </div> 

            <div className="row">
                <div className="col-md-8">
                    { user && !user.expired ? <AuditLogsPanel /> : <></>}
                </div>
            </div>
        </div>
    );
};

export default Home;